import React from 'react';
import about from '../../Assets/Images/about.svg';
import '../../Assets/Css/Aboutus.css';

const AboutUsSection = () => {
  return (
    <div className="about-us-container" id="about"> {/* Parent container for the whole section */}
      <h2 className='aboutus-heading'> About Us</h2>
      <div className="about-us-section">
        {/* Image Section */}
        <div className="image-section">
          <img
            src={about}
            alt="Prince Pictures Logo"

          />
        </div>

        {/* Content Section */}
        <div className="content-section">
          <p>
            Prince Pictures is a leading Indian film production company based in Chennai, Tamil Nadu. Founded in
            2013 by S. Lakshman Kumar, we are dedicated to
            producing compelling and high-quality content for a
            diverse audience. From action-packed thrillers to
            family-oriented dramas, our films span a wide range
            of genres, with a commitment to storytelling
            excellence.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUsSection;